/**
 * Formata o valor de um contador animado: inteiro ou decimal (vírgula pt-BR), com prefixo/sufixo.
 * `valor` aceita número ou texto («3.5», «3,5», «42»). Decimais preservam a quantidade de casas.
 */
export function parseValorContador(valor: unknown): { numero: number; casas: number } {
  if (typeof valor === 'number' && Number.isFinite(valor)) {
    const casas = Number.isInteger(valor) ? 0 : Math.min(2, (String(valor).split('.')[1] ?? '').length)
    return { numero: valor, casas }
  }
  const s = String(valor ?? '')
    .trim()
    .replace(/\s/g, '')
    .replace(',', '.')
  const n = Number.parseFloat(s)
  if (!Number.isFinite(n)) return { numero: 0, casas: 0 }
  const casas = Math.min(2, (s.split('.')[1] ?? '').length)
  return { numero: n, casas }
}

export function formatarContador(
  numero: number,
  casas: number,
  prefixo?: string | null,
  sufixo?: string | null,
): string {
  const corpo = numero.toLocaleString('pt-BR', {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  })
  return `${prefixo ?? ''}${corpo}${sufixo ?? ''}`
}
